import {
  NotificationGameType,
  NotificationSystemType,
  NotificationTransactionType,
  NotificationType,
} from "@1games-ru/region-shared/dist/enums/notification/notification-cef";
import { OfferStatus, OfferType } from "@1games-ru/region-shared/dist/enums/offer/offer";
import { PaymentType } from "@1games-ru/region-shared/dist/enums/payment/payment";
import { create } from "zustand";
import { useMemo } from "react";
import { v4 } from "uuid";
// TODO: use region-shared types
import { NotificationsActionType } from "@/domains/notifications/constants/notificationsActionType";

export enum ExtendedNotificationType {
  System = NotificationType.System,
  Game = NotificationType.Game,
  Action = NotificationType.Action,
  Transaction = NotificationType.Transaction,
  Npc = NotificationType.Npc,
  Offer = "Offer",
}

// TODO: move these types somewhere else
export type NotificationItem<T = { type: string }> = {
  id: string;
  type: ExtendedNotificationType;
  createdAt: number;
  data: T;
};

export type NotificationItemGame = NotificationItem<{
  type: NotificationGameType;
  payload: { done: number; of: number } | null;
  error: string | null;
}>;

export type NotificationItemSystem = NotificationItem<{
  type: NotificationSystemType;
  error: string | null;
  payload: Record<string, unknown>;
}>;

export type NotificationItemTransaction = NotificationItem<{
  type: NotificationTransactionType;
  paymentType: PaymentType;
  amount: number;
}>;

export type NotificationItemAction = NotificationItem<{
  type: NotificationsActionType;
}>;

export type NotificationItemOffer = NotificationItem<{
  type: OfferType;
  baseCharacterId: number;
  baseCharacterName: string;
  targetCharacterId: number;
  targetId: number;
  quantity: number;
  amount: number;
  payload: Record<string, unknown>;
  status: OfferStatus;
  createdAt: string;
  destroyAt: string;
}>;

// Store
type NotificationState = {
  stack: NotificationItem[];
};

type AddNotification = {
  id?: string;
  type: ExtendedNotificationType;
  data: { type: string } & Record<string, unknown>;
};

type NotificationActions = {
  addNotification: (notification: AddNotification) => string;
  removeNotification: (id: string) => void;
};

type NotificationStore = NotificationState & NotificationActions;

export const useNotificationStore = create<NotificationStore>()((set) => ({
  stack: [],

  addNotification: (payload) => {
    const id = v4();
    const item: NotificationItem = {
      id: payload.id ?? id,
      type: payload.type,
      data: payload.data,
      createdAt: Date.now(),
    };

    set((state) => ({
      stack: [...state.stack, item],
    }));

    return id;
  },

  removeNotification: (id) => {
    set((state) => ({
      stack: state.stack.filter((n) => n.id !== id),
    }));
  },
}));

export function useFilteredNotifications(types: ExtendedNotificationType[]) {
  const { stack } = useNotificationStore();
  return useMemo(() => stack.filter((n) => types.includes(n.type)), [types, stack]);
}
